import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { unoTheme } from '../../assets/styles/unoTheme';
import MyLinearProgressWithLabel from './MyLinearProgressWithLabel';
import { applyMaskCnpj } from './utils';

const useStyles = makeStyles((theme) => ({

    progressBox: {
        padding: '8px 4px 16px 4px',
    },

    progressLabel: {
        fontSize: '13px',
        color: unoTheme.defaultTextColor,
        marginTop: '4px',
    },

    resultBox: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(2),
    },

    resultSuccess: {
        fontSize: '13px',
        color: unoTheme.successColor,
    },

    resultFailureTitle: {
        fontSize: '13px',
        fontWeight: 600,
        color: unoTheme.errorColor,
        marginBottom: '4px',
    },

    resultFailureItem: {
        fontSize: '12px',
        color: unoTheme.defaultTextColor,
    },
}));

/**
 * O cnpj dos fundos já vem mascarado do banco; applyMaskCnpj só aceita os 14 dígitos
 */
export function formatCnpj(cnpj) {

    if (!cnpj) return '-';
    return cnpj.toString().includes('.') ? cnpj : applyMaskCnpj(cnpj);
}

/**
 * Progresso e resultado de uma atualização em massa (doBulkUpdateQuotasByListFunds /
 * doBulkUpdateInfosByListFunds). Enquanto roda mostra a barra com o fundo da vez; ao terminar,
 * mostra quantos foram atualizados e a lista de falhas com o motivo devolvido pelo servidor.
 *
 * @param {Object} progress { running, stage, current, total, label }
 * @param {Object} result { updated: [fund_id], failures: [{ fund_name, cnpj, reason }] }
 */
export default function BulkUpdateFeedback({ progress, result }) {

    const classes = useStyles();

    const running = !!(progress && progress.running);

    return (
        <>
            {
                running ?
                    <div className={classes.progressBox}>
                        <MyLinearProgressWithLabel
                            value={progress.total ?
                                Math.round((progress.current / progress.total) * 100) : 0} />
                        <div className={classes.progressLabel}>
                            {`Atualizando ${progress.stage || ''} — ${progress.label || ''} (${progress.current || 0}/${progress.total || 0})`}
                        </div>
                    </div>
                    : null
            }

            {
                !running && result ?
                    <div className={classes.resultBox}>
                        {
                            result.failures && result.failures.length ?
                                <>
                                    <div className={classes.resultFailureTitle}>
                                        {`${result.updated.length} fundo(s) atualizado(s), ${result.failures.length} com falha:`}
                                    </div>
                                    {result.failures.map((failure, index) => (
                                        <div className={classes.resultFailureItem} key={'bulk-update-failure-' + index}>
                                            {`• ${failure.fund_name} [${formatCnpj(failure.cnpj)}]: ${failure.reason}`}
                                        </div>
                                    ))}
                                </>
                                :
                                <div className={classes.resultSuccess}>
                                    {`${result.updated.length} fundo(s) atualizado(s) com sucesso.`}
                                </div>
                        }
                    </div>
                    : null
            }
        </>
    );
}
